import React, { useEffect, useState } from "react";
import './Tablero.scss'
import Eventos from "./paneles/Eventos";
import ListadoDeGuardias from "./paneles/ListadoDeGuardias";
import PanelMapa from "./paneles/PanelMapa";
import UnidadSeleccionada from "./paneles/UnidadSeleccionada";
import InformacionGeneral from "./paneles/InformacionGeneral";
import ListaServicios from "./paneles/ListaServicios";


const Tablero = () => {


    const [rutas, setRutas] = useState([])
    const [dataUnidad, setDataUnidad] = useState(null)
    const [contadorPorMinuto, setContadorPorMinuto] = useState(0)
    const [listaRutasPanelIzquierdo, setListaRutasPanelIzquierdo] = useState([]);
    const [listaRutasPanelIzquierdoUnidad, setListaRutasPanelIzquierdoUnidad] = useState([]);
    const [centrarUnidad, setCentrarUnidad] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [unidadSeleccionada, setUnidadSeleccionada] = useState(null);
    // para saber que pestaña esta activa si servicios en vivo o unidades
    const [activeIndex, setActiveIndex] = useState(0);
    const [coordenadasVistaUnidades, setCoordenadasVistaUnidades] = useState([]);
    const [dataUnidadVistaUnidad, setDataUnidadVistaUnidad] = useState(null)
    const [unidadCoordenadas, setUnidadCoordenadas] = useState([])
    const [servicios, setServicios] = useState([]);
    const [zona, setZona] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [confirmadoNoConfirmado, setConfirmadoNoConfirmado] = useState(null);
    const [tipoServicio, setTipoServicio] = useState(null);











    // console.log("zona", zona);
    // console.log("confirmadoNoConfirmado", confirmadoNoConfirmado);
    // console.log("tipoServicio", tipoServicio);

    return (
        <div className="TableroTablero">
            <div className="panel">
                <div className="cuadro1">
                    {/* <Eventos ></Eventos> */}
                    <ListaServicios
                        contadorPorMinuto={contadorPorMinuto}
                        listaRutasPanelIzquierdo={listaRutasPanelIzquierdo}
                        setListaRutasPanelIzquierdo={setListaRutasPanelIzquierdo}
                        setCentrarUnidad={setCentrarUnidad}
                        unidades={unidades}
                        // filtros
                        zona={zona}
                        cliente={cliente}
                        tipoServicio={tipoServicio}
                        confirmadoNoConfirmado={confirmadoNoConfirmado}
                        // ----
                        setActiveIndex={setActiveIndex}
                        activeIndex={activeIndex}
                        setListaRutasPanelIzquierdoUnidad={setListaRutasPanelIzquierdoUnidad}
                        listaRutasPanelIzquierdoUnidad={listaRutasPanelIzquierdoUnidad}
                        setUnidadSeleccionada={setUnidadSeleccionada}
                        unidadSeleccionada={unidadSeleccionada}
                        coordenadasVistaUnidades={coordenadasVistaUnidades}
                        setCoordenadasVistaUnidades={setCoordenadasVistaUnidades}
                        unidadCoordenadas={unidadCoordenadas}
                        servicios={servicios}
                        setServicios={setServicios}
                        setDataUnidadVistaUnidad={setDataUnidadVistaUnidad}


                    ></ListaServicios>

                </div>
                <div className="cuadro3">
                    <PanelMapa
                        listaRutasPanelIzquierdo={listaRutasPanelIzquierdo}
                        setListaRutasPanelIzquierdo={setListaRutasPanelIzquierdo}
                        listaRutasPanelIzquierdoUnidad={listaRutasPanelIzquierdoUnidad}
                        setListaRutasPanelIzquierdoUnidad={setListaRutasPanelIzquierdoUnidad}

                        contadorPorMinuto={contadorPorMinuto}
                        setContadorPorMinuto={setContadorPorMinuto}
                        setRutas={setRutas}
                        setDataUnidad={setDataUnidad}
                        dataUnidad={dataUnidad}
                        centrarUnidad={centrarUnidad}
                        setUnidades={setUnidades}
                        unidades={unidades}
                        setZona={setZona}
                        zona={zona}
                        setCliente={setCliente}
                        cliente={cliente}
                        setTipoServicio={setTipoServicio}
                        tipoServicio={tipoServicio}
                        setConfirmadoNoConfirmado={setConfirmadoNoConfirmado}
                        confirmadoNoConfirmado={confirmadoNoConfirmado}
                        activeIndex={activeIndex}
                        setUnidadSeleccionada={setUnidadSeleccionada}
                        unidadSeleccionada={unidadSeleccionada}
                        setCoordenadasVistaUnidades={setCoordenadasVistaUnidades}
                        coordenadasVistaUnidades={coordenadasVistaUnidades}

                        setDataUnidadVistaUnidad={setDataUnidadVistaUnidad}
                        dataUnidadVistaUnidad={dataUnidadVistaUnidad}
                        setUnidadCoordenadas={setUnidadCoordenadas}
                        unidadCoordenadas={unidadCoordenadas}
                        servicios={servicios}

                    ></PanelMapa>
                </div>
                <div className="cuadro4">
                    <UnidadSeleccionada
                        dataUnidad={unidadSeleccionada ? unidadSeleccionada : dataUnidad}
                        unidadCoordenadas={unidadCoordenadas}
                        setDataUnidadVistaUnidad={setDataUnidadVistaUnidad}
                        dataUnidadVistaUnidad={dataUnidadVistaUnidad}
                        activeIndex={activeIndex}
                    ></UnidadSeleccionada>
                </div>
                <div className="cuadro5">
                    <ListadoDeGuardias rutas={rutas}></ListadoDeGuardias>
                    {/* <InformacionGeneral></InformacionGeneral> */}
                </div>
            </div>
        </div>
    )
}
export default Tablero